import {
  Box,
  Breadcrumbs,
  Container,
  Grid,
  Link,
  Typography,
} from "@material-ui/core";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { Helmet } from "react-helmet-async";
import { Link as RouterLink } from "react-router-dom";
import DateRangePickerCustom from "../../components/dashboard/DateRangePicker";
import OfferAutocomplete from "../../components/dashboard/OfferAutocomplete";
import PredictedTrendsWithSelects from "../../components/dashboard/charts/PredictedTrendsWithSelects";
import ChevronRightIcon from "../../icons/ChevronRight";
import { hasPermission } from "../../utils/handlePermissions";
import { useTranslation } from "react-i18next";

const OfferByDepartureDates = () => {
  const { t } = useTranslation();

  return (
    <>
      {hasPermission("dashboard_analytics_offer") && (
        <>
          <Helmet>
            <title>
              Dashboard: {t("title.Offer by departure dates")} | Qtravel Search
            </title>
          </Helmet>
          <Box
            sx={{
              backgroundColor: "background.default",
              minHeight: "100%",
              py: 4,
            }}
          >
            <Container>
              <Grid
                container
                alignItems="end"
                justifyContent="space-between"
                spacing={3}
              >
                <Grid item>
                  <Typography color="textPrimary" variant="h5">
                    {t("title.Offer by departure dates")}
                  </Typography>
                  <Breadcrumbs
                    aria-label="breadcrumb"
                    separator={<ChevronRightIcon fontSize="small" />}
                    sx={{ mt: 1 }}
                  >
                    <Link
                      color="textPrimary"
                      component={RouterLink}
                      to="/dashboard/main"
                      variant="subtitle2"
                    >
                      Dashboard
                    </Link>
                    <Typography color="textSecondary" variant="subtitle2">
                      {t("title.Offer by departure dates")}
                    </Typography>
                  </Breadcrumbs>
                </Grid>
                <Grid item>
                  <DateRangePickerCustom
                    color={"primary"}
                    label={"Analyze the data over a range of"}
                  />
                </Grid>
              </Grid>
              <Typography color="textSecondary" variant="h6" sx={{ py: 3 }}>
                {t("pages.prediction.select_msg")}
              </Typography>
              <Box sx={{ display: "flex" }}>
                <OfferAutocomplete />
                <DateRangePickerCustom color={"warning"} label={""} />
              </Box>
              <Box sx={{ backgroundColor: "background.default", pt: 3 }}>
                <PredictedTrendsWithSelects
                  categories={[
                    "March",
                    "April",
                    "May",
                    "June",
                    "July",
                    "August",
                    "September",
                    "October",
                  ]}
                  data={{
                    min: [
                      1700.4, 2700, 3400.5, 3400.5, 4400.5, 4800.8, 5100.8,
                      4000.6,
                    ],
                    max: [
                      2300.1, 3100, 3800.1, 3900, 4500.1, 5800.9, 5800.5,
                      6600.5,
                    ],
                    avg: [2000, 2900, 3700, 3600, 4400, 5200, 5500, 5800],
                  }}
                  title={"Departure month"}
                  tooltipInfo={t(`other.tooltip_Destination_country_1`)}
                />
              </Box>
            </Container>
          </Box>
        </>
      )}
    </>
  );
};

export default OfferByDepartureDates;
